import React, { useContext, useEffect, useRef, useState } from 'react'
import NewsFilters from './NewsFilters'
import queryString from 'query-string'

const NewsAll = () => {
  const [categories, setCategories] = useState([])
  const [newsAll, setNewsAll] = useState([])
  const [newsLoaded, setNewsLoaded] = useState(false)
  const [newsCount, setNewsCount] = useState([])

  const [filters, setFilters] = useState({
    categories: [],
    query: '',
    page: 1
  })

  useEffect(() => {
    const query = queryString.stringify(filters, {
      arrayFormat: 'bracket',
    })

    fetch(`/news_posts/all.json?${query}`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data.categories)

        if (filters.page === 1) {
          setNewsAll(data.newsAll)
        } else {
          const updatedPosts = [...newsAll].concat(data.newsAll)
          setNewsAll(updatedPosts)
        }

        setNewsCount(data.newsPostCount)
        setNewsLoaded(true)
      })
  }, [filters])

  const loadPosts = () => {
    const updatedFilters = {...filters, page: filters.page + 1}
    setFilters(updatedFilters)
  };

  return (
    <div>
      {newsLoaded ? (
        <NewsFilters
          categories={categories}
          currentFilters={filters}
          filterChange={setFilters}
        />
      ) : null}

      <section className='news'>
        <section className='news__hero'>
          {newsAll.length > 0 ? (
            <div className='news__cards'>
              {newsAll.map((post, index) => (
                <div key={index} className={post.featured ? 'news__cards__card featured-card' : 'news__cards__card news-card'}>
                  {post.featured ? (
                    <a
                      href={post.link ? post.link : post.slug}
                      className='featured-card__image-container-link-wrapper'
                    >
                      <div className='featured-card__image-container'>
                        {post.imgUrl ? (
                          <img
                            src={post.imgUrl}
                            alt={post.imgAlt}
                            className='featured-card__image-container__image'
                          />
                        ) : (
                          <img
                            src='/assets/news-placeholder-image1.png'
                            alt='RADical ImPAct Placeholder Image'
                            className='featured-card__image-container__image'
                          />
                        )}
                        <div className='featured-card__image-container__featured'>
                          <p>Featured Asset</p>
                        </div>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={post.link ? post.link : post.slug}
                      className='news-card__image-container-link-wrapper'
                    >
                      <div className='news-card__image-container'>
                        {post.imgUrl ? (
                          <img
                            src={post.imgUrl}
                            alt={post.imgAlt}
                            className='news-card__image-container__image'
                          />
                        ) : (
                          <img
                            src='/assets/news-placeholder-image1.png'
                            alt='RADical ImPAct Placeholder Image'
                            className='news-card__image-container__image'
                          />
                        )}
                      </div>
                    </a>
                  )}

                  <div className='news-card__content'>
                    {post.newsType ? (
                      <p className='news-card__content__date'>
                        {post.publishedAt} <span className="news-card__content__date__divider">|</span> {post.newsType}
                      </p>
                    ) : (
                      <p className='news-card__content__date'>
                        {post.publishedAt}
                      </p>
                    )}
                    <h3 className='news-card__content__heading'>
                      {post.link ? (
                        <a
                          href={post.link}
                          className='news-card__content__heading__link news-card__content__heading__link--external'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {post.customText}
                        </a>
                      ) : (
                        <a
                          href={post.slug}
                          className='news-card__content__heading__link'
                        >
                          {post.title}
                        </a>
                      )}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          ) : newsLoaded ? (
            <p>There are no post.</p>
          ) : null}

          {newsCount > newsAll.length ? (
            <div className='news__cards__all-posts'>
              <button
                onClick={loadPosts}
                className='news__cards__all-posts__button button'
              >
                Load More Stories
              </button>
            </div>
          ) : (
            <div></div>
          )}
        </section>
      </section>
    </div>
  )
}

export default NewsAll
